// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import ValidateAddressRequestViewModel from '../../viewModel/request/Address/ValidateAddressRequestViewModel';
import AddressValidationResourceViewModel from '../../viewModel/resource/AddressValidationResourceViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async validateAddress(request: ValidateAddressRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-validate-address'] ?? 'Address/Validate';
    const response = await service.get<any>(endpointPath, {
      query: {
        countryIso2: requestDTO.countryIso2,
        street: requestDTO.street,
        houseNumber: requestDTO.houseNumber,
        postalCode: requestDTO.postalCode,
        postalCodeAddition: requestDTO.postalCodeAddition,
        city: requestDTO.city,
        limit: requestDTO.limit,
      },
      ...config,
    });
    const dto = response.data.result;
    return new AddressValidationResourceViewModel().fromDTO(dto);
  },
});
